import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propStr } from '../../../helpers/custom-prop-types';
import { HeaderLogo } from '../../Ui/Logo';
import HeaderHumMenu from '../HeaderHumMenu';
import HeaderMenuButton from '../HeaderMenuButton';
import HeaderNotificationButton from '../HeaderNotificationButton';
import HeaderHumMenuList from './HeaderHumMenuList';
const HeaderProfessional = (props) => {
    const { headerClassName, hideSpHum, isShowProffitSearch, isShowSpHum, toggleSpHum, } = props;
    return (_jsx("header", Object.assign({ className: `l-header login-consultant ${headerClassName}` }, { children: _jsxs("div", Object.assign({ className: 'l-container' }, { children: [_jsx(HeaderLogo, { topUrl: '/mypage' }), _jsx(HeaderHumMenu, Object.assign({ hideSpHum: hideSpHum, isShowSpHum: isShowSpHum, toggleSpHum: toggleSpHum }, { children: _jsx(HeaderHumMenuList, { isShowProffitSearch: isShowProffitSearch }) })), _jsxs("aside", Object.assign({ className: 'header-account' }, { children: [_jsx(HeaderMenuButton, {}), _jsx(HeaderNotificationButton, {})] }))] })) })));
};
HeaderProfessional.propTypes = {
    headerClassName: propStr(),
    hideSpHum: propFunc().isRequired,
    isShowProffitSearch: propBool().isRequired,
    isShowSpHum: propBool().isRequired,
    toggleSpHum: propFunc().isRequired,
};
HeaderProfessional.defaultProps = {
    headerClassName: '',
};
export default HeaderProfessional;
